import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.slice.js";
import { computed, defineComponent, ref } from "vue";
import { useI18n } from "vue-i18n";
import eraseSign from "@/assets/images/svg/erase-sign.svg";
import hideEye from "@/assets/images/svg/hide-eye.svg";
import BookingModule from "@/store/modules/booking";
export default defineComponent({
  name: "NumericCalculator",
  props: ["visible"],
  emits: ["closeCalc"],
  setup: function setup(props) {
    var _useI18n = useI18n({}),
        t = _useI18n.t;

    var iconStyle = "width: 40px; height: 25px;";
    var iconContent = eraseSign;
    var iconAlt = "erase";
    var hideIcon = hideEye;
    var hideIconAlt = "hide";
    var hideIconStyle = "width: 20px; height: 20px;";
    var inputContent = computed(function () {
      return BookingModule.getCalculatorValue;
    });
    var calcVisibility = ref(props.visible);

    function clearInput() {
      BookingModule.setCalcValue("0");
    }

    function eraseFromInput() {
      var length = inputContent.value.length;

      if (inputContent.value.length === 1) {
        if (inputContent.value[length - 1] !== "0") {
          var newInput = inputContent.value.replace(inputContent.value[length - 1], "0");
          BookingModule.setCalcValue(newInput);
          return;
        }

        if (inputContent.value[length - 1] === "0") {
          return;
        }
      }

      BookingModule.setCalcValue(inputContent.value.slice(0, length - 1));
    }

    function updateInput(event) {
      var char = event.target.textContent || "";

      if (inputContent.value === "0") {
        BookingModule.setCalcValue(char);
        return;
      }

      BookingModule.setCalcValue(inputContent.value + char);
    }

    return {
      inputContent: inputContent,
      clearInput: clearInput,
      eraseFromInput: eraseFromInput,
      updateInput: updateInput,
      t: t,
      iconStyle: iconStyle,
      iconContent: iconContent,
      iconAlt: iconAlt,
      hideIconAlt: hideIconAlt,
      hideIcon: hideIcon,
      hideIconStyle: hideIconStyle,
      props: props,
      calcVisibility: calcVisibility
    };
  }
});